<template>
    <div class="card-body"  @click="jumpDetail(dataSource.id, dataSource.model)">
        <div class="header"
             v-if="dataSource.user">
            <div class="avatar">
<!--                <img :src="dataSource.user.image"-->
<!--                     alt="">-->
                <van-image
                    width="40"
                    height="40"
                    :src="dataSource.user.image"
                    round
                    lazy-load
                />
                <div class="gender"
                     v-if="dataSource.user.gender == 'm'"></div>
                <div class="gender gender-blue"
                     v-else></div>
            </div>
            <div class="info">
                <div class="name">
                    <span>{{dataSource.user.nickname}}</span>
                    <div class="level">{{dataSource.user.level}}</div>
                </div>
                <div class="time">{{dataSource.create_time}}</div>
            </div>
        </div>
        <div class="title ellipsis2">{{dataSource.content}}</div>
        <!-- 1-图片 2-视频 3-音频 -->
        <template v-if="dataSource.model == 1">
            <!-- 只有1张图片时，显示大图,大于1张时，显示多图 -->
            <div v-if='dataSource.image.length>1'
                 class="pic-list">
                <div class="body-pic-img"
                     v-for='(pic,index) of dataSource.image'
                     :key='index'>
<!--                    <img class='body-pic'-->
<!--                         :src="pic.image"-->
<!--                         @click.stop='predivImage(pic,index)' />-->
                    <van-image
                        width="112"
                        height="112"
                        lazy-load
                        :src="pic.image"
                        @click.stop='predivImage(pic,index)'
                    />
                </div>
            </div>
            <template v-else>
                <div class="video-box"
                     v-if='dataSource.image[0]'>
                    <img class='video-pic'
                         :src="dataSource.image[0].image"
                         mode='aspectFill' />
                </div>
            </template>
        </template>
        <template v-if='dataSource.model===2'>
            <div class="video-box">
                <img class='video-pic'
                     :src="dataSource.video[0]&&dataSource.video[0].poster" />
                <div class="play-btn">
                    <span class="iconfont icon-play"></span>
                </div>
            </div>
        </template>
        <template v-if='dataSource.model===3'>
            <div class="radio-box" @click.stop="playAudio">
                <div class="radio-left">
                    <div :class="{'left-img-box': true, 'playing': play}">
                        <img class='radio-pic'
                             src="../assets/img/logo.png"
                             mode="scaleToFill" />
                    </div>
                    <span style="font-size: 14px" v-if="!play">点击播放音频</span>
                    <span style="font-size: 14px" v-else>点击停止播放</span>
                    <div class="left-text ellipsis">{{dataSource.title}}</div>
                </div>
                <div class="radio-right">
                    <span class="iconfont icon-play" v-if="!play"></span>
                    <span class="iconfont icon-pause" v-else></span>
                </div>
            </div>
        </template>
        <div class="operate">
            <div class="item" @click.stop="openDownModal">
                <span class="iconfont icon-thumb"></span>
                {{dataSource.like}}
            </div>
            <div class="item" @click.stop="openDownModal">
                <span class="iconfont icon-message"></span>
                {{dataSource.comment_num}}
            </div>
            <div class="item" @click.stop="openDownModal">
                <span class="iconfont icon-fenxiang"></span>
                转发
            </div>
        </div>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';
export default {
    components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
    data() {
        return {
            play: false
        };
    },
    props: {
        dataSource: {
            type: Object,
            default() {
                return {};
            },
        },
        audio: {
            type: [HTMLAudioElement, Object],
            default() {
                return {};
            }
        }
    },
    methods: {
        jumpDetail(id, type){
            this.$router.push({ path: "/new/postDetail",query: {id:id, type: type} })
        },
        playAudio() {
            this.play = !this.play;
            let url = this.dataSource.audio[0].audio
            if (this.play) {
                this.audio.src = url;
                this.audio.load();
                this.audio.play()
            } else {
                this.audio.pause();
            }
        },
        predivImage(pic,index) {
            console.log(pic.image);
            console.log(index);
            ImagePreview([pic.image]);
        },
    },
};
</script>

<style lang="less" scoped>
.ellipsis2{
		overflow: hidden;
		text-overflow: ellipsis;
		display:-webkit-box;
		-webkit-box-orient:vertical;
		-webkit-line-clamp:2;
	}
.card-body {
    background: #fff;
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 17px;
    margin-top: 16px;
    .header {
        display: flex;
        align-items: center;
        .avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 8px;
            position: relative;
        }
        .avatar > img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
        .info {
            .name {
                font-size: 14px;
                display: flex;
                align-items: center;
                .level {
                    font-size: 9px;
                    padding: 2px 4px;
                    border-radius: 4px;
                    background-color: #ffedef;
                    color: #ff4c67;
                    transform: scale(0.8);
                }
            }
            .time {
                font-size: 12px;
                color: #a7a7a7;
                margin-top: 2px;
            }
        }
    }
    .title {
        font-size: 16px;
        color: #222;
        margin: 16px 0;
    }
    .operate {
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        font-size: 12px;
        .item {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #646464;

            .iconfont {
                margin-right: 5px;
                font-size: 16px;
                font-weight: 500;
            }
        }
    }
}
.pic-list {
    display: grid;
    grid-template-columns: repeat(3, 32%);
    grid-template-rows: repeat(auto-fill, 112px);
    justify-content: space-between;
    grid-row-gap: 5px;
    margin-bottom: 16px;
    .body-pic-img {
        width: 100%;
        height: 112px;
        border-radius: 6px;
        overflow: hidden;
    }
    .body-pic-img > img {
        width: 100%;
        height: 100%;
    }
}
// .body-pic-img {
//     position: relative;
//     flex-shrink: 0;
//     margin-right: 8px;
//     margin-bottom: 8px;
//     width: 112px;
//     height: 112px;
//     overflow: hidden;
//     border-radius: 12px;

//     &:nth-child(3n) {
//         margin-right: 0;
//     }
// }

.video-box {
    position: relative;
    width: 268px;
    height: 151px;
    overflow: hidden;
    border-radius: 6px;
    margin-bottom: 16px;

    .video-pic {
        position: absolute;
        width: 268px;
        height: 151px;
        object-fit: cover;
    }

    .play-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 40px;
        height: 40px;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        background-color: rgba(34, 34, 34, 0.6);
        color: #fff;
        font-size: 12px;

        .btn-icon {
            width: 24px;
            height: 24px;
        }
    }
}

.radio-box {
    margin-bottom: 16px;
    height: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f0f0f0;
    border-radius: 100px;

    .radio-left {
        display: flex;
        align-items: center;

        .left-img-box {
            position: relative;
            flex-shrink: 0;
            margin: 0 4px;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            overflow: hidden;
            .icon {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 36px;
                height: 36px;
            }
            &.playing:before{
                content: "";
                background-image: url("../assets/img/ic_live.gif");
                background-size: cover;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 70%;
                height: 70%;
                z-index: 100;
            }
            &.playing:after{
                content: "";
                background-color: rgba(0,0,0,.4);
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
            }
        }
        .left-img-box > img {
            width: 100%;
            height: 100%;
        }
        .left-text {
            max-width: 400px;
            font-size: 14px;
            color: #222222;
        }
    }

    .radio-right {
        margin-right: 8px;
        width: 28px;
        height: 28px;
        background-color: #ff4c67;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        .iconfont {
            font-size: 10px;
        }
    }
}
</style>
